//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Chip from '@components/atoms/chip/Chip';
import Fade from '@components/atoms/fade/Fade';
import { useSmartInputContext } from '@components/molecules/smart-input/SmartInputContext';
import { IRecommendedHashtag } from '@components/molecules/smart-input/smartInputModel';
import { SmartInputTrackingId } from '@components/molecules/smart-input/smartInputTrackingIds';
import { getSmartInputTrackingId } from '@components/molecules/smart-input/smartInputUtils';

interface OwnProps {
  onClick: (value: string) => void;
  recommendation: IRecommendedHashtag;
}

type Props = OwnProps;

export const HashtagButton = ({ onClick, recommendation }: Props) => {
  const smartInputContext = useSmartInputContext();

  return (
    <StyledFade role='list-item' shouldShow={recommendation.shouldShow}>
      <Chip
        aria-label={`Add ${recommendation.value} hashtag`}
        functionalIcon='new'
        onClick={() => onClick(recommendation.value)}
        size='large'
        text={recommendation.value}
        trackingId={getSmartInputTrackingId(
          smartInputContext.trackingIdPrefix,
          SmartInputTrackingId.AddRecommendedHashtag,
        )}
      />
    </StyledFade>
  );
};

const StyledFade = styled(Fade)(
  ({ theme }) => `
  margin: 0 ${theme.spacings[2]} ${theme.spacings[2]} 0;
`,
);
